export default "/wp-content/themes/onnit/script/cart/dist/abInstant-fe0a5a1e.jpg";